"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ItemBoundable = _interopRequireDefault(require("./ItemBoundable"));

var _hasInterface = _interopRequireDefault(require("../../../../../hasInterface"));

var _ItemVisitor = _interopRequireDefault(require("../ItemVisitor"));

var _AbstractNode = _interopRequireDefault(require("./AbstractNode"));

var _Collections = _interopRequireDefault(require("../../../../../java/util/Collections"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _Serializable = _interopRequireDefault(require("../../../../../java/io/Serializable"));

var _Assert = _interopRequireDefault(require("../../util/Assert"));

var _List = _interopRequireDefault(require("../../../../../java/util/List"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AbstractSTRtree =
/*#__PURE__*/
function () {
  function AbstractSTRtree() {
    _classCallCheck(this, AbstractSTRtree);

    AbstractSTRtree.constructor_.apply(this, arguments);
  }

  _createClass(AbstractSTRtree, [{
    key: "queryInternal",
    value: function queryInternal() {
      if ((0, _hasInterface.default)(arguments[2], _ItemVisitor.default) && arguments[0] instanceof Object && arguments[1] instanceof _AbstractNode.default) {
        var searchBounds = arguments[0],
            node = arguments[1],
            visitor = arguments[2];
        var childBoundables = node.getChildBoundables();

        for (var i = 0; i < childBoundables.size(); i++) {
          var childBoundable = childBoundables.get(i);

          if (!this.getIntersectsOp().intersects(childBoundable.getBounds(), searchBounds)) {
            continue;
          }

          if (childBoundable instanceof _AbstractNode.default) {
            this.queryInternal(searchBounds, childBoundable, visitor);
          } else if (childBoundable instanceof _ItemBoundable.default) {
            visitor.visitItem(childBoundable.getItem());
          } else {
            _Assert.default.shouldNeverReachHere();
          }
        }
      } else if ((0, _hasInterface.default)(arguments[2], _List.default) && arguments[0] instanceof Object && arguments[1] instanceof _AbstractNode.default) {
        var _searchBounds = arguments[0],
            _node = arguments[1],
            matches = arguments[2];

        var childBoundables = _node.getChildBoundables();

        for (var i = 0; i < childBoundables.size(); i++) {
          var childBoundable = childBoundables.get(i);

          if (!this.getIntersectsOp().intersects(childBoundable.getBounds(), _searchBounds)) {
            continue;
          }

          if (childBoundable instanceof _AbstractNode.default) {
            this.queryInternal(_searchBounds, childBoundable, matches);
          } else if (childBoundable instanceof _ItemBoundable.default) {
            matches.add(childBoundable.getItem());
          } else {
            _Assert.default.shouldNeverReachHere();
          }
        }
      }
    }
  }, {
    key: "getNodeCapacity",
    value: function getNodeCapacity() {
      return this._nodeCapacity;
    }
  }, {
    key: "lastNode",
    value: function lastNode(nodes) {
      return nodes.get(nodes.size() - 1);
    }
  }, {
    key: "size",
    value: function size() {
      if (arguments.length === 0) {
        if (this.isEmpty()) {
          return 0;
        }

        this.build();
        return this.size(this._root);
      } else if (arguments.length === 1) {
        var node = arguments[0];
        var size = 0;

        for (var i = node.getChildBoundables().iterator(); i.hasNext();) {
          var childBoundable = i.next();

          if (childBoundable instanceof _AbstractNode.default) {
            size += this.size(childBoundable);
          } else if (childBoundable instanceof _ItemBoundable.default) {
            size += 1;
          }
        }

        return size;
      }
    }
  }, {
    key: "removeItem",
    value: function removeItem(node, item) {
      var childToRemove = null;

      for (var i = node.getChildBoundables().iterator(); i.hasNext();) {
        var childBoundable = i.next();

        if (childBoundable instanceof _ItemBoundable.default) {
          if (childBoundable.getItem() === item) childToRemove = childBoundable;
        }
      }

      if (childToRemove !== null) {
        node.getChildBoundables().remove(childToRemove);
        return true;
      }

      return false;
    }
  }, {
    key: "itemsTree",
    value: function itemsTree() {
      if (arguments.length === 0) {
        this.build();
        var valuesTree = this.itemsTree(this._root);
        if (valuesTree === null) return new _ArrayList.default();
        return valuesTree;
      } else if (arguments.length === 1) {
        var node = arguments[0];
        var valuesTreeForNode = new _ArrayList.default();

        for (var i = node.getChildBoundables().iterator(); i.hasNext();) {
          var childBoundable = i.next();

          if (childBoundable instanceof _AbstractNode.default) {
            var valuesTreeForChild = this.itemsTree(childBoundable);
            if (valuesTreeForChild !== null) valuesTreeForNode.add(valuesTreeForChild);
          } else if (childBoundable instanceof _ItemBoundable.default) {
            valuesTreeForNode.add(childBoundable.getItem());
          } else {
            _Assert.default.shouldNeverReachHere();
          }
        }

        if (valuesTreeForNode.size() <= 0) return null;
        return valuesTreeForNode;
      }
    }
  }, {
    key: "insert",
    value: function insert(bounds, item) {
      _Assert.default.isTrue(!this._built, "Cannot insert items into an STR packed R-tree after it has been built.");

      this._itemBoundables.add(new _ItemBoundable.default(bounds, item));
    }
  }, {
    key: "boundablesAtLevel",
    value: function boundablesAtLevel() {
      if (arguments.length === 1) {
        var level = arguments[0];
        var boundables = new _ArrayList.default();
        this.boundablesAtLevel(level, this._root, boundables);
        return boundables;
      } else if (arguments.length === 3) {
        var _level = arguments[0],
            top = arguments[1],
            _boundables = arguments[2];

        _Assert.default.isTrue(_level > -2);

        if (top.getLevel() === _level) {
          _boundables.add(top);

          return null;
        }

        for (var i = top.getChildBoundables().iterator(); i.hasNext();) {
          var boundable = i.next();

          if (boundable instanceof _AbstractNode.default) {
            this.boundablesAtLevel(_level, boundable, _boundables);
          } else {
            _Assert.default.isTrue(boundable instanceof _ItemBoundable.default);

            if (_level === -1) {
              _boundables.add(boundable);
            }
          }
        }

        return null;
      }
    }
  }, {
    key: "query",
    value: function query() {
      if (arguments.length === 1) {
        var searchBounds = arguments[0];
        this.build();
        var matches = new _ArrayList.default();

        if (this.isEmpty()) {
          return matches;
        }

        if (this.getIntersectsOp().intersects(this._root.getBounds(), searchBounds)) {
          this.queryInternal(searchBounds, this._root, matches);
        }

        return matches;
      } else if (arguments.length === 2) {
        var _searchBounds2 = arguments[0],
            visitor = arguments[1];
        this.build();

        if (this.isEmpty()) {
          return null;
        }

        if (this.getIntersectsOp().intersects(this._root.getBounds(), _searchBounds2)) {
          this.queryInternal(_searchBounds2, this._root, visitor);
        }
      }
    }
  }, {
    key: "build",
    value: function build() {
      if (this._built) return null;
      this._root = this._itemBoundables.isEmpty() ? this.createNode(0) : this.createHigherLevels(this._itemBoundables, -1);
      this._itemBoundables = null;
      this._built = true;
    }
  }, {
    key: "getRoot",
    value: function getRoot() {
      this.build();
      return this._root;
    }
  }, {
    key: "remove",
    value: function remove() {
      if (arguments.length === 2) {
        var searchBounds = arguments[0],
            item = arguments[1];
        this.build();

        if (this.getIntersectsOp().intersects(this._root.getBounds(), searchBounds)) {
          return this.remove(searchBounds, this._root, item);
        }

        return false;
      } else if (arguments.length === 3) {
        var _searchBounds3 = arguments[0],
            node = arguments[1],
            _item = arguments[2];
        var found = this.removeItem(node, _item);
        if (found) return true;
        var childToPrune = null;

        for (var i = node.getChildBoundables().iterator(); i.hasNext();) {
          var childBoundable = i.next();

          if (!this.getIntersectsOp().intersects(childBoundable.getBounds(), _searchBounds3)) {
            continue;
          }

          if (childBoundable instanceof _AbstractNode.default) {
            found = this.remove(_searchBounds3, childBoundable, _item);

            if (found) {
              childToPrune = childBoundable;
              break;
            }
          }
        }

        if (childToPrune !== null) {
          if (childToPrune.getChildBoundables().isEmpty()) {
            node.getChildBoundables().remove(childToPrune);
          }
        }

        return found;
      }
    }
  }, {
    key: "createHigherLevels",
    value: function createHigherLevels(boundablesOfALevel, level) {
      _Assert.default.isTrue(!boundablesOfALevel.isEmpty());

      var parentBoundables = this.createParentBoundables(boundablesOfALevel, level + 1);

      if (parentBoundables.size() === 1) {
        return parentBoundables.get(0);
      }

      return this.createHigherLevels(parentBoundables, level + 1);
    }
  }, {
    key: "depth",
    value: function depth() {
      if (arguments.length === 0) {
        if (this.isEmpty()) {
          return 0;
        }

        this.build();
        return this.depth(this._root);
      } else if (arguments.length === 1) {
        var node = arguments[0];
        var maxChildDepth = 0;

        for (var i = node.getChildBoundables().iterator(); i.hasNext();) {
          var childBoundable = i.next();

          if (childBoundable instanceof _AbstractNode.default) {
            var childDepth = this.depth(childBoundable);
            if (childDepth > maxChildDepth) maxChildDepth = childDepth;
          }
        }

        return maxChildDepth + 1;
      }
    }
  }, {
    key: "createParentBoundables",
    value: function createParentBoundables(childBoundables, newLevel) {
      _Assert.default.isTrue(!childBoundables.isEmpty());

      var parentBoundables = new _ArrayList.default();
      parentBoundables.add(this.createNode(newLevel));
      var sortedChildBoundables = new _ArrayList.default(childBoundables);

      _Collections.default.sort(sortedChildBoundables, this.getComparator());

      for (var i = sortedChildBoundables.iterator(); i.hasNext();) {
        var childBoundable = i.next();

        if (this.lastNode(parentBoundables).getChildBoundables().size() === this.getNodeCapacity()) {
          parentBoundables.add(this.createNode(newLevel));
        }

        this.lastNode(parentBoundables).addChildBoundable(childBoundable);
      }

      return parentBoundables;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      if (!this._built) return this._itemBoundables.isEmpty();
      return this._root.isEmpty();
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return AbstractSTRtree;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Serializable.default];
    }
  }], [{
    key: "compareDoubles",
    value: function compareDoubles(a, b) {
      return a > b ? 1 : a < b ? -1 : 0;
    }
  }]);

  return AbstractSTRtree;
}();

exports.default = AbstractSTRtree;

function IntersectsOp() {}

AbstractSTRtree.IntersectsOp = IntersectsOp;

AbstractSTRtree.constructor_ = function () {
  this._root = null;
  this._built = false;
  this._itemBoundables = new _ArrayList.default();
  this._nodeCapacity = null;

  if (arguments.length === 0) {
    AbstractSTRtree.constructor_.call(this, AbstractSTRtree.DEFAULT_NODE_CAPACITY);
  } else if (arguments.length === 1) {
    var nodeCapacity = arguments[0];

    _Assert.default.isTrue(nodeCapacity > 1, "Node capacity must be greater than 1");

    this._nodeCapacity = nodeCapacity;
  }
};

AbstractSTRtree.serialVersionUID = -3886435814360241337;
AbstractSTRtree.DEFAULT_NODE_CAPACITY = 10;